import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import SectionHeading from "../components/Common/SectionHeading";
import Head from 'next/head';
import Link from 'next/link';
import axios from 'axios';
import { faqsList } from '../components/Common/DataSet/MainData';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));

const AccordionSection = dynamic(() => import('../components/Common/AccordionSection', { ssr: false }));



const TermsAndConditions = () =>  {
  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)


  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])

  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    if (index === activeAccordion) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(index);
    }
  };



  return (
    <>


      <Navbar />
      <>
        <HeroBanner
          background={process.env.IMG_CDN + "img/banner/terms-and-condition-page.webp"}
          title={<>DelveInsight&apos;s Terms and Conditions</>}
        />
        <Breadcrumb />
        <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
          <SectionHeading
            title="Welcome to DelveInsight's Terms and Conditions"
          />
          <div className='grid grid-cols-12'>
            <div className='col-span-12'>
              <div className='text-justify'>
                <p>The mentioned terms and Conditions mark the outline of the rules and regulations for the use of our company. They represent an understanding and an agreement between the company and the individual or entity using the website.</p>
                <p>By using this website, we assume that you agree to comply with all of the Terms of Use.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Use of Content, and Restriction</h3>
                <p>The site and all the content available on DelveInsight are the property of the company and affiliates or licensors and are protected by patent, copyright, trademark, and other intellectual property laws. All the information on the site is for the sole informational and non-commercial use of the visitor.</p>
                <p>You are authorized to make copies, print, or distribute the content provided on the website for informational purposes. However, you are barred from modifying, selling, exploiting, distributing, or making any commercial benefits out of it. The copies you plan to use must include the copyright notice and associated attributions. You may not use the materials available of DelveInsight in a manner that may constitute an infringement of our rights, or we have not authorized that.</p>
                <p>You are also not authorized to use any graphics, proprietary processes, or any technology described on the website.</p>
                <p>While you read these Terms of Use, you agree to comply with all applicable laws in accessing and using DelveInsight.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Use Of Cookies</h3>
                <p>By accessing DelveInsight, you agree to use all the cookies in agreement with the company&apos;s privacy policy. We employ the use of cookies primarily for tracking the usage of the website and studying the clients’ browsing and purchasing behavior.</p>
                <p>You have the choice of disabling or refusing the cookies via your web browser preferences. That may result in disabling some functionalities of our website. Also, you can reset your web browser to refuse cookies to notify you when a cookie is being sent.</p>
                <p>However, cookies allow you to have access to some of the best features of the company. Thus, we recommend you to leave them turned on.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Personal Information</h3>
                <p>We store the information provided by the visitor or client while subscribing to our website&apos;s alerts. We also have access to details entered by you while interacting with us via chatbots or when adding comments on certain parts of the website.</p>
                <p>We safeguard the information you choose to entrust us with through this website.</p>
                <p>We use the stored or provided information for purposes such as responding to requests, informing about the launch of the latest products/services, communicating, customizing the future experience, and improving our products and services.</p>
                <p>We might obtain or receive information about you or your organization to the degree permitted by law, from other third-party sources. We combine such third sourced information with information we have obtained about you from our site, and we treat the combined information in accordance with the practices described under our aforementioned Privacy Policy.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Provision Of Services</h3>
                <p>DelveInsight performs all the services and provides all the products in compliance with all the applicable laws, regulations and codes of professional conduct, following the terms and agreement, with reasonable skills and care, and per sound professional practice.</p>
                <section>
                  <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">FAQ&apos;s</h3>
                  <AccordionSection data={faqsList} />
                </section>
                <h3 className="text-lg font-semibold my-4 text-[#1b5df3]">Disclaimer</h3>
                <p>All the information published on this website is in good faith and for the purpose of fulfilling general information only. DelveInsight has the sole right to every piece of information provided. Readers are requested to use the information for non-commercial purposes only after consent.</p>
                <p>From the website, readers can be directed to external ethical and useful websites through hyperlinks. DelveInsight takes no responsibility for the information provided there and has no control over the content and nature of external sites. DelveInsight by no means promotes or recommends the use of the content or products listed on the external sites.</p>
                <p>Please be aware that DelveInsight and other linked websites follow different privacy guidelines and consent terms that are beyond the control of the company. DelveInsight requests users and readers to check the ‘Terms and Conditions’ and ensure safety before diving into any Business relationship with external companies.</p>
                <hr />
                <p>You may contact DelveInsight via email at
                  <Link href="mailto:info@delveinsight.com"  className='text-[#1b5df3]'>
                    <strong> info@delveinsight.com</strong>
                  </Link> for further assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
      {scrolledStatus && <>
        <Footer />
      </>}

    </>
  )
}

TermsAndConditions.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}


export default TermsAndConditions;

